import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let BusRouteController = {
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-route/create`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-route/edit`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    search: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-route/search`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-route/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    delete: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-route/delete/${id}`,
            method: 'GET'
        }, callback)
    },

    detailRegister: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-route/detail-register/${id}`,
            method: 'GET'
        }, callback)
    },

    registerBusUserService: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-route/register-bus-user-service`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    editBusUserRegister: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-route/edit-bus-user-register`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    cancelBusUserRegister: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-route/cancel-bus-user-register`,
            method: 'POST',
            body: payload,
        }, callback);
    },

    reportBusUserPayment: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-route/report-bus-user-payment`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    searchBusUserPayment: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-route/search-bus-user-payment`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    updateBusUserPayment: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-route/update-bus-user-payment`,
            method: 'POST',
            body: payload,
        }, callback);
    },
    searchManager: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/bus-route/search-manager`,
            method: 'POST',
            body: payload,
        }, callback);
    },
}

export default BusRouteController
